export default __webpack_public_path__ + "static/media/seasonal_depression.150a9e71.png";